import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class RoutingStateService {
    private history = [];

    constructor(
        private router: Router
    ) { }

    /**
     * @description Start subscribing to and storing route history.
     */
    public loadRouting(): void {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
                this.history = [...this.history, urlAfterRedirects];
            });
    }

    /**
     * @description Return the full history state.
     */
    public getHistory(): string[] {
        return this.history;
    }

    /**
     * @description Return the previous URL.
     */
    public getPreviousUrl(): string {
        return this.history[this.history.length - 2] || '/';
    }

    /**
     * @description Return a URL by index.
     */
    public getPreviousBy(index: number = 0): string {
        return this.history[this.history.length - index] || '/';
    }
}
